import { Box, withStyles } from '@material-ui/core';
import {
  SelectedOptions,
  SelectedOptionsProps
} from './components/selected-options';

const SelectedOptionsContainer = withStyles(theme => ({
  root: {
    position: 'fixed',
    bottom: 20,
    left: '50%',
    transform: 'translateX(-50%)',
    // Above page content (e.g. table loaders/skeletons that would otherwise
    // paint over the fixed bar), below dialogs (modal: 1300) and snackbars.
    zIndex: theme.zIndex.appBar
  }
}))(Box);

export const ActionBar = <T,>(props: SelectedOptionsProps<T>) => (
  <SelectedOptionsContainer>
    <SelectedOptions {...props} />
  </SelectedOptionsContainer>
);
